import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

Vue.use(Router)

let router = new Router({

  routes: [

    {
      path: '*',
      name: 'login',

      component: () => import('../page/login/loginNew')
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('../components/homePage/index')
    },
    {
      path: '/achievementsPage',
      name: 'achievementsPage',
      component: () => import('../components/homePage/achievementsPage')
    },
    {
      path: '/productPage',
      name: 'productPage',
      component: () => import('../components/homePage/productPage')
    },
    {
      path: '/applicationPage',
      name: 'applicationPage',
      component: () => import('../components/homePage/applicationPage')
    },
    {
      path: '/adminPage',
      name: 'adminPage',
      component: () => import('../components/homePage/adminPage'),
      children:[
        {
          path:'/adminPage',
          name:'用户管理',
          component:()=>import('../components/homePage/adminUser')
        },
        {
          path:'/adminLiterature',
          name:'文献资料',
          component:()=>import('../components/homePage/adminLiterature')
        },
        {
          path:'/adminDeclare',
          name:'项目申报',
          component:()=>import('../components/homePage/adminDeclare')
        },
        {
          path:'/adminAchievements',
          name:'算法与成果',
          component:()=>import('../components/homePage/adminAchievements')
        },
        {
          path:'/adminProduct',
          name:'产品与案例',
          component:()=>import('../components/homePage/adminProduct')
        },


      ]
    },
    {
      path: '/literaturePage',
      name:'literaturePage',
      component: () => import('../components/homePage/literaturePage'),
      children:[
        {
          path:'/home/category',
          name:'category',
          component:()=>import('../components/standard/category/index')
        },
        {
          path:'/home/sort',
          name:'sort',
          component:()=>import('../components/standard/sort/index')
        },{
          path:'/home/serviceSpecial',
          name:'serviceSpecial',
          component:()=>import('../components/service/serviceSpecial/index')
        },{
          path:'/home/authorize',
          name:'authorize',
          component:()=>import('../components/service/authorize/index')
        },{
          path:'/home/effect',
          name:'effect',
          component:()=>import('../components/service/effect/index')
        },{
          path:'/home/user',
          name:'user',
          component:()=>import('../components/system/user/index')
        },{
          path:'/home/role',
          name:'role',
          component:()=>import('../components/system/role/index')
        },{
          path:'/home/menu',
          name:'menu',
          component:()=>import('../components/system/menu/index')
        }
        ,{
          path:'/home/userMenu',
          name:'userMenu',
          component:()=>import('../components/system/userMenu/index')
        },{
          path:'/service/serviceCode',
          name:'serviceCode',
          component:()=>import('../components/service/serviceCode/index')
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  // const JSESSIONID = Cookies.get('token')
  // if (to.path === '/' || JSESSIONID) {

    next()
  // } else {
  //
  //   next({
  //     path: '/'
  //   })
  // }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js